import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Message() {
    const [chat, setChat] = useState([]);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            const elem = document.getElementById('chatt');
            elem.scrollTop = elem.scrollHeight;
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleChange = (e) => {
        console.log(e.target.value);
        setMsg(e.target.value);
    };

    const handleSend = () => {
        if (msg !== '') {
            axios.post('https://cricketqnaapi.pythonanywhere.com/user', { 'msg': msg })
                .then(res => {
                    const updatedChat = [...chat, { from: 'our', msag: msg }, { from: 'cb', msag: res.data }];
                    setChat(updatedChat);
                    setMsg('');
                    console.log(updatedChat);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    return (
        <div>
            <div className='chatContainer'>
                <div id='chatt' className='chatt' style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                    {
                        chat.map((msg) => {
                            if (msg.from === 'cb') {
                                return <div className="bot">
                                    {/* <img className="logo" src={images} alt="bot Logo" /> */}
                                    {msg.msag} </div>
                            } else {
                                return <div className="user">{msg.msag}</div>
                            }
                        })
                    }
                </div>
            </div>
            <div style={{ height: '10px' }}>
                <div className="input" >
                    <input
                        type='text'
                        name='msg'
                        placeholder="What would you like to ask the bot..."
                        onChange={(e) => handleChange(e)}
                        className="form-control"
                        value={msg}
                    />
                    <button onClick={() => handleSend()} className="btn btn-primary"><b>Send a Message 🚀</b></button>
                </div>
            </div>
        </div>
    );
}

export default Message;